module.exports = __webpack_public_path__ + "static/media/logo2.8990e9c4.png";